/**
 * Gets vars that are prepended with dollar signs.
 *
 * @param string - a string with vars like so: 'Sometimes $name likes $noun.'
 * @returns {Array} - an array of the names of the vars: [name, noun].
 */
module.exports = (string) => {
  const re = /(?:^|\W)\$(\w+)(?!\w)/g;
  const matches = [];
  let match;

  while (match = re.exec(string)) {
    matches.push(match[1]);
  }

  return matches;
};
